import { configureStore } from '@reduxjs/toolkit';
import onboardingUserDataReducer from '../features/onboardingData/onboardingUserData';

export const store = configureStore({
  reducer: {
    onboardingUserData: onboardingUserDataReducer,
  },
})